exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sad span{\r\n    color: #aaaaaa;\r\n    font-size: 50px;\r\n}\r\n.sad{\r\n    text-align: center;\r\n    margin-top: 5%;\r\n}\r\n.homepage-link{\r\n    text-align: center;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/page-not-found/page-not-found.component.css
// module id = 470
// module chunks = 1